/**
 * Size Guide Modal & Tab Functionality
 */

class SizeGuideModal {
    constructor() {
      this.modal = document.getElementById('SizeGuideModal');
      if (!this.modal) return;
  
      this.closeBtn = this.modal.querySelector('#ModalClose-SizeGuide');
      this.tabs = this.modal.querySelectorAll('.size-guide-tabs__tab');
      this.panels = this.modal.querySelectorAll('.size-guide-tabs__panel');
      this.scrollbarWidth = this.getScrollbarWidth();
  
      this.init();
    }
  
    init() {
      // Tab click events
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });
  
      // Close button click
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }
  
      // Click outside to close
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.hide();
        }
      });
  
      // ESC key to close
      document.addEventListener('keyup', (e) => {
        if ((e.key === 'Escape' || e.code === 'Escape') && this.modal.hasAttribute('open')) {
          this.hide();
        }
      });
  
      // Watch for open attribute changes (when modal-opener triggers)
      this.observeModalState();
  
      // Initialize drag-to-scroll for tabs navigation
      this.initTabsDragScroll();
    }
  
    initTabsDragScroll() {
      const tabsNav = this.modal.querySelector('.size-guide-tabs__nav');
      if (!tabsNav) return;
  
      let isDown = false;
      let startX;
      let scrollLeft;
  
      tabsNav.addEventListener('mousedown', (e) => {
        isDown = true;
        tabsNav.style.cursor = 'grabbing';
        startX = e.pageX - tabsNav.offsetLeft;
        scrollLeft = tabsNav.scrollLeft;
      });
  
      tabsNav.addEventListener('mouseleave', () => {
        isDown = false;
        tabsNav.style.cursor = 'grab';
      });
  
      tabsNav.addEventListener('mouseup', () => {
        isDown = false;
        tabsNav.style.cursor = 'grab';
      });
  
      tabsNav.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tabsNav.offsetLeft;
        const walk = (x - startX) * 1.5;
        tabsNav.scrollLeft = scrollLeft - walk;
      });
  
      // Set initial cursor
      tabsNav.style.cursor = 'grab';
    }
  
    observeModalState() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            if (this.modal.hasAttribute('open')) {
              this.onOpen();
            } else {
              this.onClose();
            }
          }
        });
      });
  
      observer.observe(this.modal, { attributes: true });
    }
  
    getScrollbarWidth() {
      // Create a temporary div to measure scrollbar width
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);
  
      const inner = document.createElement('div');
      outer.appendChild(inner);
  
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      outer.parentNode.removeChild(outer);
  
      return scrollbarWidth;
    }
  
    hasScrollbar() {
      return document.documentElement.scrollHeight > document.documentElement.clientHeight;
    }
  
    onOpen() {
      document.body.classList.add('size-guide-modal-open');
      // ModalDialog.show() (global.js) adds the 'overflow-hidden' class to body
      // before this callback runs. base.css applies a hardcoded padding-right:15px
      // via that class for legacy scroll-lock compensation. Remove the class here
      // so its CSS rule never fires; we apply scroll-lock via inline styles below.
      document.body.classList.remove('overflow-hidden');

      // On browsers without scrollbar-gutter:stable support, manually compensate
      // body + fixed header for the scrollbar space that disappears with overflow:hidden.
      if (!(CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'))) {
        const sw = window.innerWidth - document.documentElement.clientWidth;
        if (sw > 0) {
          document.body.style.paddingRight = sw + 'px';
          document.querySelectorAll(
            '.shopify-section-group-header-group, .section-header'
          ).forEach(el => { el.style.paddingRight = sw + 'px'; });
        }
      }

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    onClose() {
      document.body.classList.remove('size-guide-modal-open');
      this.modal.removeAttribute('data-user-opened');

      document.body.style.paddingRight = '';
      document.querySelectorAll(
        '.shopify-section-group-header-group, .section-header'
      ).forEach(el => { el.style.paddingRight = ''; });

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  
    hide() {
      this.modal.removeAttribute('open');
      this.onClose();
    }
  
    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const tabKey = clickedTab.dataset.tab;
  
      // Remove active class from all tabs
      this.tabs.forEach((tab) => tab.classList.remove('active'));
  
      // Remove active class from all panels
      this.panels.forEach((panel) => panel.classList.remove('active'));
  
      // Add active class to clicked tab
      clickedTab.classList.add('active');
  
      // Add active class to corresponding panel
      const activePanel = this.modal.querySelector(`[data-panel="${tabKey}"]`);
      if (activePanel) {
        activePanel.classList.add('active');
      }
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SizeGuideModal());
  } else {
    new SizeGuideModal();
  }
